// extracted by mini-css-extract-plugin
export default {"section":"ChartSection_section__Qx0U9","sectionTitle":"ChartSection_sectionTitle__V9mn0","chartContainer":"ChartSection_chartContainer__pFw6q"};